import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@app/componentlib/src/store'
import { apiUrl } from '@app/componentlib/src/application/helpers/api'
import { httpService } from '@app/componentlib/src/services/HttpService';
import { ProfileData } from '@app/componentlib/src/common/types/profileTypes'
import Vue from 'vue'

declare module 'vue/types/vue' {
  interface VueConstructor {
    http: any
  }
}

export interface IProfileState {
  _initialized: boolean
  _profileData: ProfileData | undefined
  _gdprData: string
}

@Module({
  dynamic: true,
  store,
  name: 'Profile',
  namespaced: true
})
class Profile extends VuexModule implements IProfileState {
  _initialized = false
  _profileData: ProfileData | undefined = undefined
  _gdprData: string = ''

  @Action({ rawError: true })
  async init () {
    await this.getProfileData()
    console.log('PROFILE: Initialized')
    this.context.commit('SET_INITIALIZED', true)
  }

  @Action({ rawError: true })
  async getProfileData () {
    const api = 'MemberApi'
    const endpoint = 'GetProfileData'
    await httpService.get(apiUrl(api, endpoint)).then((profileData: any) => {
      profileData.competences.skills = profileData.skills
      const data: ProfileData = {
        competences: profileData.competences,
        experiences: profileData.experiences
      }
      console.log('GET PROFILE DATA: ', data)
      this.context.commit('SET_PROFILEDATA', data)
    })
  }

  @Action({ rawError: true })
  async setGdprData (data: string) {
    this.context.commit('SET_GDPRDATA', data)
  }

  @Mutation
  SET_INITIALIZED (val: boolean) {
    this._initialized = val
  }
  @Mutation
  SET_PROFILEDATA (val: ProfileData) {
    this._profileData = val
  }
  @Mutation
  SET_GDPRDATA (val: string) {
     Vue.set(this, '_gdprData', val)
  }

  //Getters
  get initialized (): boolean {
    return this._initialized
  }

  get profileData (): ProfileData | undefined {
    return this._profileData
  }
  get gdprData (): string {
    return this._gdprData
  }
}

export const ProfileModule = getModule(Profile)
